import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ApiInterceptor implements HttpInterceptor {
  private baseUrl = environment.API_URL;

  constructor(private router: Router) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const isFullUrl = req.url.startsWith('https');

    const apiReq = req.clone({
      url: isFullUrl ? req.url : `${this.baseUrl}/${req.url}`,
    });

    return next
      .handle(apiReq)
      .pipe(catchError((error) => this.handleError(error)));
  }

  private handleError(error: HttpErrorResponse) {
    console.error('Erro HTTP:', error);
    if (error.status === 401) {
      this.router.navigate(['/login']);
    }

    let message = 'Erro desconhecido!';

    if (error.error instanceof ErrorEvent) {
      message = `${error.error}`;
    } else {
      switch (error.status) {
        case 0:
          message = 'Não foi possível conectar ao servidor.';
          break;
        case 400:
          message = error.error;
          break;
        case 401:
          message = 'Não autorizado.';
          break;
        case 404:
          message = 'Recurso não encontrado.';
          break;
        case 500:
          message = error.error;
          break;
        default:
          message = `Erro ${error.status}: ${error.message}`;
          break;
      }
    }
    return throwError(() => message);
  }
}
